import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import '../App.css';

export default function FooterControl(props) {

   const [value, setValue] = React.useState(30);
   const [prevDeltaScene, setPrevDeltaScene] = React.useState(0);
   const [zoombarValue, setZoombarValue] = React.useState(0);

   const handleChange = (event, newValue) => {
      setValue(newValue);
   };

   const handleZoomChange = (e, newValue) => {
      if (e) {
         window.scene._nav.NavChangeDolly(undefined, e.target.value / 100);
      } else {
         window.scene._nav.NavChangeDolly(undefined, newValue / 100);
         document.getElementById("sliderRange").value = newValue;
      }
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }
      window.hidePopUp();
      window.hotspot = '';
      window.portClicked = '';
      var sliderValues = document.getElementById('sliderRange').value * 100;
      document.getElementById('sliderRange').setAttribute('aria-label', '');
      setTimeout(function () {
         document.getElementById('sliderRange').setAttribute('aria-label', '%');
      }, 400);
         
         if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
            window.zoonOutCamStatus = false;
            var allPopup = document.querySelector('.popup.active');
            if (allPopup != null) {
               allPopup.classList.remove('active');
            }
            var center = [0,0,0];
               window.scene._nav.SetRotationCenter(center);
            if (window.zoomOutPort == "quickAccessPorts") {
               window.scene.groupApplyState("STAND_ON");
               window.scene.groupApplyState("REF_BOX_ON");
               window.scene.groupApplyState("GP_ON");
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }
                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
      
            } else if (window.zoomOutPort == "ports") {
               window.portFirstClick = false;
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }

                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
            }else if (window.zoomOutPort == "back") {
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }
      
                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
            }
         }
   };

   //only for mob
   const [camData, setCamData] = useState("");
   var animationSwitch = window.Animation;
   var animTime = 1;

   const onZoomIn = (e) => {
      if (window.scene._nav.getZoomFactor() > 0)
         handleZoomChange(null, -1 + (parseFloat(document.getElementById("sliderRange").value)));

         if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
            window.zoonOutCamStatus = false;
            var allPopup = document.querySelector('.popup.active');
            if (allPopup != null) {
               allPopup.classList.remove('active');
            }
            var center = [0,0,0];
               window.scene._nav.SetRotationCenter(center);
            if (window.zoomOutPort == "quickAccessPorts") {
               window.scene.groupApplyState("STAND_ON");
               window.scene.groupApplyState("REF_BOX_ON");
               window.scene.groupApplyState("GP_ON");
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }
                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
      
            } else if (window.zoomOutPort == "ports") {
               window.portFirstClick = false;
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }
                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
            }else if (window.zoomOutPort == "back") {
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }
      
                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
            }
         }

   }

   const onZoomOut = (e) => {
      if (window.scene._nav.getZoomFactor() < 100)
         handleZoomChange(null, 1 + (parseFloat(document.getElementById("sliderRange").value)));

         
         if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
            window.zoonOutCamStatus = false;
            var allPopup = document.querySelector('.popup.active');
            if (allPopup != null) {
               allPopup.classList.remove('active');
            }
            var center = [0,0,0];
               window.scene._nav.SetRotationCenter(center);
            if (window.zoomOutPort == "quickAccessPorts") {
               window.scene.groupApplyState("STAND_ON");
               window.scene.groupApplyState("REF_BOX_ON");
               window.scene.groupApplyState("GP_ON");
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }
                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
      
            } else if (window.zoomOutPort == "ports") {
               window.portFirstClick = false;
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }

                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
            }else if (window.zoomOutPort == "back") {
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }
      
                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
            }
         }
   }
   const onLeft = () => {
      window.scene._nav.NavRotation([0, 0], [2, 0]);
      window.hotspot = '';
      window.hidePopUp();
      window.portClicked = '';
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }
      
         
         if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
            window.zoonOutCamStatus = false;
            var allPopup = document.querySelector('.popup.active');
            if (allPopup != null) {
               allPopup.classList.remove('active');
            }
            var center = [0,0,0];
               window.scene._nav.SetRotationCenter(center);
            if (window.zoomOutPort == "quickAccessPorts") {
               window.scene.groupApplyState("STAND_ON");
               window.scene.groupApplyState("REF_BOX_ON");
               window.scene.groupApplyState("GP_ON");
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }
                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
      
            } 
            else if (window.zoomOutPort == "ports") {
               window.portFirstClick = false;
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }

                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
            }else if (window.zoomOutPort == "back") {
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }
      
                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
            }
         }
      window.scene.clearRefine();
   }
   const onRight = () => {
      window.scene._nav.NavRotation([0, 0], [-2, 0]);
      window.hotspot = '';
      window.hidePopUp();
      window.portClicked = '';
      if (window.selectedButton != 'accordion_interiorFeatur') {
         window.selectedButton = '';
      }
         
         if (window.zoonOutCamStatus == true && window.zoomOutCam != "") {
            window.zoonOutCamStatus = false;
            var allPopup = document.querySelector('.popup.active');
            if (allPopup != null) {
               allPopup.classList.remove('active');
            }
            var center = [0,0,0];
               window.scene._nav.SetRotationCenter(center);
            if (window.zoomOutPort == "quickAccessPorts") {
               window.scene.groupApplyState("STAND_ON");
               window.scene.groupApplyState("REF_BOX_ON");
               window.scene.groupApplyState("GP_ON");
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }
                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
      
            } else if (window.zoomOutPort == "ports") {
               window.portFirstClick = false;
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }

                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
            }else if (window.zoomOutPort == "back") {
               window.GotoPosInTimeNamedValue(window.zoomOutCam, function () {
                  // update the scroll bar
                  var slider = document.getElementById("sliderRange");
                  if (slider != null) {
                     document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
                     setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
                  }
      
                  var center = [0, 20.774332, 0];
                  window.scene._nav.SetRotationCenter(center);
               });
            }
         }
      window.scene.clearRefine();
   }

   return (
      <React.Fragment>
         {ReactDOM.createPortal(
            <div id='footerControls' className="footerControlsDesk">
               <div className="threebtns">
                  <div className="zoombarandRotateContainer">

                     <div className='topbtns'  >
                        <button className='navBtn footerBtn floatleft' aria-label="Rotate" id="rLeft" tabIndex="-1" onClick={onLeft} title="left">
                           <img alt="Rotate left" src="./images/diagonalLeftArrow.svg" />
                        </button>
                        <button className='navBtn footerBtn' aria-label="Rotate" id="rRight" tabIndex="-1" onClick={onRight} title="right">
                           <img alt="Rotate right" src="./images/diagonalRightArrow.svg" />
                        </button>
                     </div>

                     <div id="zoomSliderContainer " className='zoombar'>
                        <img style={{ height: '100%' }} alt="zoombar" src="./images/ZOOMBAR.svg" />

                        <button tabIndex="-1" className='navBtn MuiButtonBase-root MuiButton-root MuiButton-text' style={{ color: "#0076CE" }} type="button" aria-label="Clickable Zoom Out" role="button" id="zoomIn" onClick={onZoomIn}> </button>
                        <div id="zoomSlider" aria-hidden="true">
                           <div className="rangeslider" aria-hidden="true">
                              <label> <input tabIndex="-1" aria-hidden="true" type="range" min="0" max="100" step="1" className="myslider" onChange={handleZoomChange} id="sliderRange" />
                              </label>
                           </div>
                        </div>
                        <button className='navBtn MuiButtonBase-root MuiButton-root MuiButton-text' tabIndex="-1" style={{ color: "#0076CE" }} type="button" id="zoomOut" role="button" aria-label="Clickable Zoom In" onClick={onZoomOut}></button>
                     </div>
                  </div>
                  <div className='clearBoth' >
                     <button tabIndex="-1" className='navBtn threeButtons' aria-label="Previous view" id="previousView" variant="outlined" color="primary" onClick={props.onPrevious} >
                        <img alt="Previous view" src="./images/leftArrow.svg" style={{ paddingRight: '12px', height: '20px', width: '24px', verticalAlign: 'middle'  }}/>Previous View
                     </button>
                     <button tabIndex="-1" className='navBtn threeButtons' variant="outlined" id="resetView" color="primary" onClick={props.onReset} >
                        Reset View
                     </button>
                     <button tabIndex="-1" className='navBtn threeButtons' aria-label="Next view" id="nextView" variant="outlined" color="primary" onClick={props.onNext} expanded={props.expanded} >
                        Next View<img alt="Next view" src="./images/rightArrow.svg" style={{ paddingLeft: '12px', height: '20px', width: '24px', verticalAlign: 'middle'  }}/>
                     </button>
                  </div>
               </div>
            </div>, document.getElementById('footerControlDesk')
         )}
      </React.Fragment>

   );
}
